// slices/jobManagementSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Define an async thunk to fetch jobs with filters and pagination
export const fetchJobs = createAsyncThunk(
  'jobManagement/fetchJobs',
  async ({ currentPage, itemsPerPage, statusFilter, fromDate, toDate, searchTerm }, { rejectWithValue }) => {
    try {
      const ticketToken = sessionStorage.getItem('ticketToken');
      console.log("redux");
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/provider/get-job-postings`, {
        headers: {
          Authorization: `Bearer ${ticketToken}`,
        },
        params: {
          page: currentPage,
          limit: itemsPerPage,
          status: statusFilter,
          fromDate,
          toDate,
          searchTerm,
        },
      });

      // Map over each job to add appliedCandidatesCount based on the appliedCandidates array length
      const updatedJobs = response.data.data.map((job) => ({
        ...job,
        appliedCandidatesCount: job.appliedCandidates ? job.appliedCandidates.length : 0,
      }));

      // return response.data;
      return { data: updatedJobs, totalPages:  Math.ceil(response.data.totalCount / itemsPerPage) };

    } catch (error) {
      return rejectWithValue(error.response.data || error.message);
    }
  }
);
const jobManagementSlice = createSlice({
  name: 'jobManagement',
  initialState: {
    jobs: [],
    totalPages: 1,
    loading: false,
    error: null,
    currentPage: 1,
    statusFilter: '',
    searchTerm: '',
    fromDate: null,
    toDate: null,
  },
  reducers: {
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setStatusFilter(state, action) {
      state.statusFilter = action.payload;
    },
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    },
    setFromDate(state, action) {
      state.fromDate = action.payload;
    },
    setToDate(state, action) {
      state.toDate = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.loading = false;
        state.jobs = action.payload.data;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setStatusFilter, setSearchTerm, setFromDate, setToDate } = jobManagementSlice.actions;

export default jobManagementSlice.reducer;
